import { render, staticRenderFns } from "./InfoEmpresaMovil.vue?vue&type=template&id=23d4165e"
import script from "./InfoEmpresaMovil.vue?vue&type=script&lang=js"
export * from "./InfoEmpresaMovil.vue?vue&type=script&lang=js"
import style0 from "./InfoEmpresaMovil.vue?vue&type=style&index=0&id=23d4165e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports